module.exports = __webpack_public_path__ + "img/a6ff375.png";